import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
  SHOW_POPUP_UPGRADE_CONNECT_MAP,
} from '../../../../helpers/EventEmitter'
import DashboardService from '../../../core/service'

export const getCurrentPlan = createAsyncThunk(
  'dashboard/currentPlan/getCurrentPlan',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getCurrentPlan(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getUserPricingPackages = createAsyncThunk(
  'dashboard/currentPlan/getUserPricingPackages',
  async (_, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getUserPricingPackages()
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getTrialList = createAsyncThunk(
  'dashboard/currentPlan/getTrialList',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getTrialList(params)
      if (res.success) {
        return res
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const checkRequestConnectMap = createAsyncThunk(
  'dashboard/currentPlan/checkRequestConnectMap',
  async (data, { rejectWithValue }) => {
    try {
      const res = await DashboardService.checkRequestConnectMap(data)
      if (res.success) {
        if (res.data) {
          EventEmitter.dispatch(
            SHOW_POPUP_CONFIRMATION,
            'domesticSearchPreview.CONTACT_US_CONFIRM',
          )
        } else {
          EventEmitter.dispatch(SHOW_POPUP_UPGRADE_CONNECT_MAP)
        }
      }
      return rejectWithValue('Error')
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
